import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import PageLoader from "~/components/Page/PageLoader";
import { LOAD_COMPANY, LOAD_FAILURE } from "~/store/action_types";
import { loadCompany } from "~/store/actions/actions.companies";
import { getCompanyById } from "~/store/selectors/selector.companies";

export const RequireExistingCompanyAccess = ({ children, redirectTo }) => {
  const dispatch = useDispatch();
  const { companyId } = useParams();

  const [loading, setLoading] = useState(true);
  const company = useSelector((state) => getCompanyById(state, +companyId));

  useEffect(() => {
    if (!company && !!companyId) {
      dispatch(loadCompany(+companyId)).then((res) => {
        if (res.type === LOAD_COMPANY || res.type === LOAD_FAILURE) setLoading(false);
      });
    } else if (company) {
      setLoading(false);
    }
  }, [company, companyId, dispatch]);

  if (loading) return <PageLoader />;

  return company && !company?.is_trashed ? children : <Navigate to={redirectTo} />;
};

RequireExistingCompanyAccess.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireExistingCompanyAccess.defaultProps = {
  redirectTo: "/companies",
};
